import axios from 'axios';
import type {
    TGetAllPortfoliosPayload,
    TGetPlausibilityCheckSavingsPlan,
    TGetContactPortfolioOrderbook,
} from './types';

export const getAllPortfolios = ({ contactId, language = 'en' }: TGetAllPortfoliosPayload) => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.0/contacts/${contactId}/portfolios?language=${language}`,
);

export const getPlausibilityCheckSavingsPlan = async (
    { portfolioId }: TGetPlausibilityCheckSavingsPlan,
) => axios.get(
    `${global?.AppConfig?.DSL_URL_SUFFIX}/v1/portfolios/${portfolioId}/plausibility-check/savings-plan`,
);

export const getContactPortfolioOrderbook = (
    { clientId, portfolioId }:TGetContactPortfolioOrderbook,
) => axios.get(
    `${global?.AppConfig?.DSL_URL_SUFFIX}/v1.0/contacts/${clientId}/portfolios/${portfolioId}/orderbook`,
);
